import React, { useState } from 'react';
import { ListBase, useTranslate } from 'react-admin';
import DatagridCustom from '../../Components/DatagridCustom/DatagridCustom';
import dayjs from 'dayjs';
import TextFieldBase from '../../Components/CustomFields/TextFieldBase/TextFieldBase';
import CardDefault from '../../Components/CardDefault/CardDefault';
import ActionsListTransactions from '../../Components/ActionsListTransactions/ActionsListTransactions';
import TopToolbarList from '../../Components/TopToolbarList/TopToolbarList';
import { FaBtc } from 'react-icons/fa';
import FiltersList from '../../Components/FiltersList/FiltersList';
import LoadingCustom from '../../Components/LoadingCustom/LoadingCustom';
import { useSelector } from 'react-redux';
import PaginationCustom from '../../Components/PaginationCustom/PaginationCustom';
import CustomEmpty from '../../Components/CustomEmpty/CustomEmpty';
import TextFieldRefund from '../../Components/CustomFields/TextFieldRefund/TextFieldRefund';
import useCopyClipboard from '../../Hooks/useCopyClipboard';
import { formatMount } from '../../helpers/multiuso';
import WrapperComponent from '../../Components/WrapperComponent/WrapperComponent';
import { Box, Typography } from '@mui/material';

const formatTime = (time) => {
  return dayjs(time).format('HH:mm');
};

// Función clave para determinar el monto en ARS usando la "foto" histórica
const calculateArsAmount = (record) => {
  if (!record) return 0;
  // Priorizamos los campos nuevos que el backend ya empezó a mandar
  const { historical_ars_rate, ars } = record;
  
  // Si el backend ya mandó el monto calculado y fijo, lo usamos de una
  if (ars !== undefined && ars !== null) return ars;
  
  // Si es una transacción vieja que solo tiene el record['ars'], lo devolvemos
  return record.ars || 0;
};

const refundedFormatMount = (record, _currency) => {
  const currency = _currency.toLowerCase();
  const rate = record.historical_ars_rate || record.usd_ars; // Fallback por las dudas

  if (currency === 'ars') {
    const mountARS = calculateArsAmount(record);
    if (record.refunded_amount) {
      // Restamos el reembolso sobre el monto congelado
      const total = (Math.trunc(mountARS) - record.refunded_amount);
      return total > 0 ? formatMount(total, currency) : '0';
    } else {
      return formatMount(mountARS, currency);
    }
  } else { 
    // Si está en dólares, usamos la tasa histórica para convertir el reembolso que está en pesos
    if (record.refunded_amount && rate) {
      const mountUSD = record.refunded_amount / rate;
      const total = Math.trunc(record[currency] - mountUSD);
      return total > 0 ? formatMount(total, currency) : '0';
    } else {
      return formatMount(record[currency], currency);
    }
  }
};

const ListTransactions = () => {
  const { selectedBranch } = useSelector(state => state.branch);
  const { selectedMerchant } = useSelector(state => state.merchant);
  const { currency } = useSelector(state => state.config);
  const { date, min_mount, max_mount, refunded } = useSelector(state => state.filter);

  const translate = useTranslate();
  const copy = useCopyClipboard();

  const copyClipHash = (hash) => {
    copy(hash);
  };

  return (
    <WrapperComponent>
      {
        !selectedMerchant ? (
          <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography>{translate('no_selected_merchant_branch')}</Typography>
          </Box>
        ) : selectedBranch?.id ? (
          <ListBase
            filter={{ date: date.format('YYYY-MM-DD'), min_ars: min_mount, max_ars: max_mount, refunded }}
            emptyWhileLoading
          >
            <TopToolbarList title={translate('activity')} icon={<FaBtc size={33} style={{ transform: 'rotate(-18deg)' }} />} />
            <FiltersList />
            <DatagridCustom
              size='small'
              noPadding
              empty={<CustomEmpty title={'empty_transactions'} />}
            >
              <TextFieldRefund
                small
                source={currency === 'ARS' ? 'ars' : 'usd'}
                label={translate('mount')}
                fontSize='14px'
                variant='primary'
                formatRecord={(record) => `${refundedFormatMount(record, currency)}`}
                sortable={false}
              />
              <CardDefault
                source={translate('time')}
                small
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, padding: '0 50px' }}
                sortable={false}
              >
                <TextFieldBase fontSize='13px' source={'time'} label={translate('time')} formatRecord={formatTime} />
              </CardDefault>
              <CardDefault
                source={translate('activity_resource.pay_id')}
                small
                style={{ width: '300px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0, padding: '0 30px' }}
                sortable={false}
              >
                <TextFieldBase
                  fontSize='13px'
                  source={'hash'}
                  style={{ direction: 'rtl', color: '#cccccc', cursor: 'pointer' }}
                  onClick={copyClipHash}
                />
              </CardDefault>
              <CardDefault small style={{ marginLeft: '12px' }}>
                <ActionsListTransactions />
              </CardDefault>
            </DatagridCustom>
            <PaginationCustom />
          </ListBase>
        ) : (
          <LoadingCustom />
        )
      }
    </WrapperComponent>
  );
};

export default ListTransactions;
